import React, {useEffect} from 'react'
import {DefaultTemplate, NoContent} from '../../components'
import {NotificationItem} from "./modals/notification-item";
import {NotificationCardView, NotificationListView} from './components'
import {Capacitor} from "@capacitor/core"
import {PushNotifications} from "@capacitor/push-notifications"

export const NotificationList = ({
                                   getNotifications,
                                   notifications,
                                   notificationView,
                                   selectNotification,
                                   dictionary,
                                   router,
                                 }) => {

  useEffect(() => {
    getNotifications()
  }, [getNotifications])

  useEffect(() => {
    if(Capacitor.getPlatform() === 'ios'){
      // This will clear the badge number on ios
      PushNotifications.removeAllDeliveredNotifications()
    }
  }, [])

  return (
      <DefaultTemplate
        refreshFunction={() => {getNotifications()}}
        pageTitle={dictionary.notifications}
        dictionary={dictionary} >

        <NoContent
          text='There are no notifications to view'
          isVisible={!notifications?.length}
        />

        {
          notificationView === 'Default'
            ?
            <NotificationListView notifications={notifications} selectNotification={selectNotification} />
            :
            <NotificationCardView notifications={notifications} selectNotification={selectNotification} />
        }

        <NotificationItem router={router} />

      </DefaultTemplate>
  )
}